module.exports = __webpack_public_path__ + "static/mpost35.2e4f8c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost35.jpg
// module id = 998
// module chunks = 35783957827783